import {HeaderMall9} from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import WhiteSpec from "../../../../../publicComponent/h5/WhiteSpec";
import OrderDetailContext, {OrderDetailController, useOrderDetailContext} from "../../../../../reducer/moduleReducer/my/orderDetail";
import {useTranslation} from "react-i18next";
import {Fragment, useEffect} from "react";
import QRCode from 'qrcode.react';

function OrderQRCodeWrap() {
  const { getOrderDetail } = OrderDetailController();
  const { state } = useOrderDetailContext();
  const { detail } = state;
  const { t } = useTranslation();
  
  useEffect(() => {
    getOrderDetail();
  }, []);
  
  return (
    <Navigator.container className="container-center">
      <h1 className="text-[24px] mt-[30px] mb-[20px] font-bold mdmax:hidden">{t('核销码')}</h1>
      
      <div className="mdmax:hidden grid grid-cols-3 gap-6">
        {
          detail.productList && detail.productList.map((item, i) => (
            <div className="py-[18px] px-[20px] bg-[#eee]"
                 key={i}>
              <div className="flex border-b border-[#ddd] pb-[12px]">
                <div className="w-[85px] h-[85px] bg-[#eee] flex-none mr-[15px] items-center">
                  <img src={item.imgPathView} style={{width: '100%',height: '100%',objectFit:'contain'}}/>
                </div>
                <div>
                  <p className="line-clamp-2">{item.productName}</p>
                  <p className="text-[#999] text-[12px]">{item.specName} x{item.productQty}</p>
                  <p className="text-[14px]">${item.productTotalPrice}</p>
                </div>
              </div>
              <div className="pt-[15px]">
                <p>已核销：{item.totalCheckProductQty - item.leftCheckProductQty || 0}</p>
                <p className="my-[12px]">未核销：{item.leftCheckProductQty || 0}</p>
                {/*<p>核销码：2022-12-12</p>*/}
                <div className="w-[120px] h-[120px] flex justify-center items-center bg-white rounded-[10px] mx-auto my-[24px] mb-[8px]">
                  <QRCode value={item.checkCode} size={100}/>
                </div>
                <div className="text-[18px] font-bold text-center">NO:{item.checkCode}</div>
              </div>
            </div>
          ))
        }
      </div>
      
      <div className="md:hidden">
        <WhiteSpec/>
        <p className="py-[10px] px-[4%] font-bold text-[16px]">{t('订单信息')}</p>
        {
          detail.productList && detail.productList.map((item, i) => (
            <Fragment key={i}>
              <div className="py-[12px]">
                {/*<WhiteSpec/>*/}
                {/*<div className="py-[18px] text-center">*/}
                {/*  <p className="text-[16px] text-[#fe4646] font-bold mb-[5px]">{t('核销码')}</p>*/}
                {/*  <p className="font-bold text-[16px] mb-[12px]">{item.checkCode}</p>*/}
                {/*  <div className="flex justify-center">*/}
                {/*    <QRCode value={item.checkCode} size={100}/>*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div className="px-[4%]">
                  <div className="flex md:hidden">
                    <div className="w-[110px] h-[110px] flex-none mr-[15px] items-center">
                      <img src={item.imgPathView} style={{width: '100%',height: '100%',objectFit:'contain'}}/>
                    </div>
                    <div className="flex-1">
                      <p className="text-[13px] line-clamp-1">{item.productName}</p>
                      <p className="text-[#999] text-[13px]">{item.specName} x{item.productQty}</p>
                      <p className="text-[14px]">${item.productTotalPrice}</p>
                      <p className="text-[14px]">{t('核销码')}:</p>
                      <p className="text-[12px]">
                        {t('已核销')}：{item.totalCheckProductQty - item.leftCheckProductQty || 0}
                      </p>
                      <p className="text-[12px]">
                        {t('未核销')}：{item.leftCheckProductQty || 0}
                      </p>
                    </div>
                    <div className="flex flex-col items-center">
                      <QRCode value={item.checkCode} size={55}/>
                      <p className="mt-[5px]">{item.checkCode}</p>
                    </div>
                  </div>
                </div>
              </div>
              <WhiteSpec/>
            </Fragment>
          ))
        }
        <div className="divide-y divide-[#eee] pt-[8px] px-[4%]">
          <div className="flex py-[12px]">
            <p className="text-[#999]">订单编号</p>
            <p className="text-right flex-1">{detail.orderNo}</p>
          </div>
          <div className="flex py-[12px]">
            <p className="text-[#999]">下单时间</p>
            <p className="text-right flex-1">{detail.createTime}</p>
          </div>
          {/*<div className="flex py-[12px]">*/}
          {/*  <p className="text-[#999]">已核销数量</p>*/}
          {/*</div>*/}
        </div>
      </div>
    </Navigator.container>
  );
}

export default function OrderQRCode() {
  return (
    <>
      <HeaderMall9/>
      <Navigator title="核销码" goback/>
      <OrderDetailContext>
        <OrderQRCodeWrap/>
      </OrderDetailContext>
    </>
  );
}
